"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDesignToTypography = exports.mapDesignToBaseColors = void 0;
var functions_1 = require("./functions");
var normalizers_1 = require("./normalizers");
var mapDesignToBaseColors = function (ds) { return ({
    white: {
        value: (0, functions_1.humanizeColor)(ds.colors.white.color),
        comment: 'Базовый белый цвет совпадает с whitePrimary',
    },
    whitePrimary: {
        value: (0, functions_1.humanizeColor)(ds.colors.white_primary.color),
        comment: 'Первичный белый цвет',
    },
    whiteSecondary: {
        value: (0, functions_1.humanizeColor)(ds.colors.white_secondary.color),
        comment: 'Вторичный белый цвет',
    },
    whiteTertiary: {
        value: (0, functions_1.humanizeColor)(ds.colors.white_tertiary.color),
        comment: 'Третичный белый цвет',
    },
    black: {
        value: (0, functions_1.humanizeColor)(ds.colors.black.color),
        comment: 'Базовый черный цвет совпадает с blackPrimary',
    },
    blackPrimary: {
        value: (0, functions_1.humanizeColor)(ds.colors.black_primary.color),
        comment: 'Первичный черный цвет',
    },
    blackSecondary: {
        value: (0, functions_1.humanizeColor)(ds.colors.black_secondary.color),
        comment: 'Вторичный черныйцвет',
    },
    blackTertiary: {
        value: (0, functions_1.humanizeColor)(ds.colors.black_tertiary.color),
        comment: 'Третичный черный цвет',
    },
    dark01: {
        value: (0, functions_1.humanizeColor)(ds.colors.dark01.color),
        comment: 'Чёрный непрозрачный, не зависит от темы',
    },
    dark02: {
        value: (0, functions_1.humanizeColor)(ds.colors.dark02.color),
        comment: 'Чёрный непрозрачный, не зависит от темы',
    },
    dark03: {
        value: (0, functions_1.humanizeColor)(ds.colors.dark03.color),
        comment: 'Чёрный непрозрачный, не зависит от темы',
    },
    transparent: {
        value: (0, functions_1.humanizeColor)(ds.colors.transparent.color),
        comment: 'Прозрачный цвет',
    },
    buttonClear: {
        value: (0, functions_1.humanizeColor)(ds.colors.button_clear.color),
        comment: 'Второстепенная прозрачная',
    },
    buttonBlack: {
        value: (0, functions_1.humanizeColor)(ds.colors.button_black.color),
        comment: 'Дефолтная чёрная, не зависит от темы',
    },
    buttonBlackSecondary: {
        value: (0, functions_1.humanizeColor)(ds.colors.button_black_secondary.color),
        comment: 'Второстепенная чёрная, не зависит от темы',
    },
    buttonBlackTransparent: {
        value: (0, functions_1.humanizeColor)(ds.colors.button_black_transparent.color),
        comment: 'Чёрная для использования поверх картинок',
    },
    buttonWhite: {
        value: (0, functions_1.humanizeColor)(ds.colors.button_white.color),
        comment: 'Дефолтная белая, не зависит от темы',
    },
    buttonWhiteSecondary: {
        value: (0, functions_1.humanizeColor)(ds.colors.button_white_secondary.color),
        comment: 'Второстепенная белая, не зависит от темы',
    },
}); };
exports.mapDesignToBaseColors = mapDesignToBaseColors;
var mapDesignToTypography = function (ds, normalize) {
    var typoStyles = {};
    var fonts = {};
    var fontWeights = {};
    var fontSizeSet = new Set();
    var lineHeightSet = new Set();
    var letterSpacingSet = new Set();
    for (var _i = 0, _a = Object.entries(ds.typography); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        var typoStyle = normalize === null || normalize === void 0 ? void 0 : normalize(value.style);
        if (key === 'underline') {
            typoStyle.textTransform = 'uppercase';
        }
        var fontFamily = typoStyle.fontFamily, fontSize = typoStyle.fontSize, fontWeight = typoStyle.fontWeight, lineHeight = typoStyle.lineHeight, letterSpacing = typoStyle.letterSpacing;
        var fontType = (0, normalizers_1.matchFontToWeight)(typoStyle);
        // https://system-ui.com/theme/
        fonts[fontType] = fontFamily;
        fontWeights[fontType] = fontWeight;
        fontSizeSet.add(fontSize);
        lineHeightSet.add(lineHeight || fontSize);
        letterSpacingSet.add(String(letterSpacing));
        typoStyles[key] = typoStyle;
    }
    var fontSizes = Array.from(fontSizeSet).sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
    var lineHeights = Array.from(lineHeightSet).sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
    var letterSpacings = Array.from(letterSpacingSet).sort(function (a, b) {
        // treat 'normal' as 0
        /* eslint-disable no-restricted-globals */
        var aa = isNaN(parseFloat(a)) ? 0 : parseFloat(a);
        var bb = isNaN(parseFloat(b)) ? 0 : parseFloat(b);
        /* eslint-enable no-restricted-globals */
        return aa - bb;
    });
    return {
        fontSizes: fontSizes,
        fonts: fonts,
        fontWeights: fontWeights,
        lineHeights: lineHeights,
        letterSpacings: letterSpacings,
        typoStyles: typoStyles,
        text: typoStyles,
    };
};
exports.mapDesignToTypography = mapDesignToTypography;
//# sourceMappingURL=mappers.js.map